import { AllocationViewActionIdentifierModel, AllocationViewArrivalDockModel } from '../../models';

export class AllocationViewArriveAtDockConfirmationAction {
  public static readonly type = '[AllocationViewArriveAtDockConfirmationAction] Dock Arrival Confirmation';

  constructor(public data: AllocationViewArrivalDockModel) {}
}

export class AllocationViewArriveAtDockConfirmationActionPrepare {
  public static readonly type = '[AllocationViewArriveAtDockConfirmationAction] Dock Arrival Confirmation Prepare';

  constructor(public identifier: AllocationViewActionIdentifierModel, public language: string) {}
}

export class AllocationViewArriveAtDockConfirmationActionSetInitialState {
  public static readonly type = '[AllocationViewArriveAtDockConfirmationAction] Set Initial State';
}
